class ScrollingShowcase {
  constructor(element) {
    this.layout = element.querySelector('.scrolling-showcase__layout');
    this.header = document.querySelector('.site-header__bar');
    this.steps = [...element.querySelectorAll('[data-showcase-index]')];
    this.images = [...element.querySelectorAll('[data-showcase-image]')];
    this.triggers = [...element.querySelectorAll('[data-showcase-trigger]')];

    this.mediaQuery = window.matchMedia('(min-width: 64rem)');

    if (this.steps.length < 2 || !this.layout) return;

    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll);
    this.mediaQuery.addEventListener('change', this.handleScroll);

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (this.mediaQuery.matches) this.setActive(Number(trigger.dataset.showcaseTrigger));
      });
    });
    this.handleScroll();
  }

  handleScroll() {
    if (this.ticking || !this.mediaQuery.matches) return;

    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.ticking = false;
      if (!this.mediaQuery.matches) return;

      const bounds = this.layout.getBoundingClientRect();
      const headerBottom = this.header ? Math.max(0, this.header.getBoundingClientRect().bottom) : 0;
      const focusLine = (window.innerHeight + headerBottom) / 2;
      // Track the block passing the viewport midpoint without reserving scroll space.
      const progress = Math.min(Math.max((focusLine - bounds.top) / Math.max(bounds.height, 1), 0), 1);
      this.setActive(Math.min(Math.floor(progress * this.steps.length), this.steps.length - 1));
    });
  }

  setActive(index) {
    if (this.activeIndex === index) return;
    this.activeIndex = index;
    this.steps.forEach((step, stepIndex) => {
      step.classList.toggle('scrolling-showcase__step--active', stepIndex === index);
    });

    this.triggers.forEach((trigger, triggerIndex) => {
      if (triggerIndex === index) {
        trigger.setAttribute('aria-current', 'true');
      } else {
        trigger.removeAttribute('aria-current');
      }
    });

    this.images.forEach((image) => {
      image.classList.toggle('scrolling-showcase__figure--active', Number(image.dataset.showcaseImage) === index);
    });
  }
}

document.querySelectorAll('.js-scrolling-showcase').forEach((element) => new ScrollingShowcase(element));
